module.exports = __webpack_public_path__ + "img/logo_podo_col_color.cc69ada1.png";